// src/pages/MentionsLegalesPage.js
import React from 'react';
import './MentionsLegalesPage.css'; // Importe ses propres styles

function MentionsLegalesPage() {
  return (
    <div className="container legal-page-container">
      <h1>Mentions Légales</h1>

      <section className="legal-section">
        <h2>1. Éditeur du Site</h2>
        <p>
          <strong>Nom de l'entreprise / Raison sociale :</strong> Info Colab
          <br />
          <strong>Forme juridique :</strong> Entreprise Individuelle (Auto-entreprise)
          <br />
          <strong>Adresse du siège social :</strong> 8 Rue de l'Eglise, 78440 Drocourt, France
          <br />
          <strong>Numéro de téléphone :</strong> +33 7 69 29 79 63
          <br />
          <strong>Adresse e-mail :</strong> contact@infocolab.com
        </p>
        <p>
          <strong>Numéro SIRET :</strong> 854 087 798 00021
          <br />
          {/* Si applicable, vous pouvez ajouter RCS et TVA ici. Pour une auto-entreprise, le RCS n'est pas toujours obligatoire pour toutes les activités, et la TVA dépend du régime. */}
          {/* <strong>Numéro d'inscription au RCS (Registre du Commerce et des Sociétés) :</strong> [Votre numéro RCS Ville] */}
          {/* <br /> */}
          {/* <strong>Numéro de TVA intracommunautaire :</strong> [Votre numéro de TVA] */}
          {/* <br /> */}
          {/* <strong>Capital social :</strong> [Montant] € */}
        </p>
        <p>
          <strong>Directeur de la publication :</strong> Leon
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Hébergement du Site</h2>
        <p>
          Le site Info Colab est hébergé par :
          <br />
          <strong>Nom de l'hébergeur :</strong> LWS
          <br />
          <strong>Adresse de l'hébergeur :</strong> 10, RUE PENTHIEVRE 75008 PARIS
          <br />
          <strong>Numéro de téléphone de l'hébergeur :</strong> 01 77 62 30 03
        </p>
      </section>

      <section className="legal-section">
        <h2>3. Propriété Intellectuelle</h2>
        <p>
          L'ensemble de ce site (contenus, textes, images, vidéos, logos, marques...) relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Info Colab.
        </p>
        <p>
          Le logo Info Colab est une marque déposée / propriété de Info Colab. Toute reproduction non autorisée de cette marque, logos et signes distinctifs constitue une contrefaçon passible de sanctions pénales.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Limitation de Responsabilité</h2>
        <p>
          Info Colab s'efforce de fournir sur le site infocolab.com des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
        </p>
        <p>
          Toutes les informations indiquées sur le site infocolab.com sont données à titre indicatif, et sont susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
        </p>
        <p>
          Le site utilise la technologie JavaScript. Le site Internet ne pourra être tenu responsable de dommages matériels liés à l’utilisation du site. De plus, l’utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour.
        </p>
        <p>
          Info Colab ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site infocolab.com, et résultant soit de l’utilisation d’un matériel ne répondant pas aux spécifications indiquées, soit de l’apparition d’un bug ou d’une incompatibilité.
        </p>
        {/* Ajoutez des clauses spécifiques si vous avez des espaces interactifs (commentaires, formulaires) */}
      </section>

      <section className="legal-section">
        <h2>5. Droit Applicable et Attribution de Juridiction</h2>
        <p>
          Tout litige en relation avec l’utilisation du site infocolab.com est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents de Versailles.
        </p>
      </section>

      <section className="legal-section">
        <p><em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}</em></p>
      </section>

    </div>
  );
}

export default MentionsLegalesPage;